export const projects = [
  {
    title: "SuperAssist",
    subtitle: "Made for Superación Juvenil A.B.P.",
    description:
      "This app was made for the forementioned non-profit organization, it was made to help them take better note of the attendance to their events",
    image: "./project-1.png",
    link: "https://play.google.com/store/apps/details?id=com.kernel_panicker.sjapp&pli=1",
  },
  {
    title: "Arca Aumentada",
    subtitle: "Made for Arca Continental for a college assignment",
    description:
      "This app is meant to be a tool to showcase some fridges they use for promotion in Augmented Reality. Due to some agreements pictures can't be shown of the project",
    image: "./logo192.png",
    link: "#Projects",
  },
  {
    title: "MiramarApp",
    subtitle: "Made for Miramar 2022 conference for religious organization Kairós",
    description: "This WebApp was used as a way to give information about the ongoing events of the conference, displaying the schedules, showing daily videos and showing the missing objects. It was updated manually by me every night at the conference",
    image: "./miramar.gif",
    link: "https://contigo22.com/",
  }
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "Web development",
  "Mobile Development",
  "JavaScript",
  "React",
  "HTML",
  "Node",
  "React Native",
  "Unity",
  "C++",
  "MSSQL",
  "Firebase",
  "MySQL"
];
